
import Navbar from './components/Navbar.vue';
import Presentation from './components/Presentation.vue';
import FeaturesItem from './components/FeaturesItem.vue';
import TestimonialsCards from './components/TestimonialsCards.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  components: {
    Navbar,
    Presentation,
    FeaturesItem,
    TestimonialsCards,
    Footer,
},
}
